import { render, staticRenderFns } from "./modal-manager.vue?vue&type=template&id=b684e46e&scoped=true"
import script from "./modal-manager.vue?vue&type=script&lang=js"
export * from "./modal-manager.vue?vue&type=script&lang=js"
import style0 from "./modal-manager.vue?vue&type=style&index=0&id=b684e46e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b684e46e",
  null
  
)

export default component.exports